import { render } from "./NavbarVisualImpairment.vue?vue&type=template&id=12a72230"
import script from "./NavbarVisualImpairment.vue?vue&type=script&lang=js"
export * from "./NavbarVisualImpairment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__